var S;!function(S){S.INSTRUMENTS="INSTRUMENTS",S.IS_TREASURY="IS_TREASURY"}(S||(S={}));export{S as QUERY_KEY};
